// Icons.js - SVG Icons for Rich App
import React from 'react';
// Pre-load and cache PXL image
import pxlCoinImage from '../images/pxl.png';

export const RichCoinIcon = React.memo(({ width = "48", height = "48" }) => {
  return (
    <img src={pxlCoinImage} alt="PXL Coin" width={width} height={height || width} style={{ objectFit: 'contain' }} />
  );
});

export const LightningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 1L3 9H7L5 15L13 7H8L9 1Z" stroke="#FFC400" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const StarIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <linearGradient id="starGradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#FF00FF" />
      <stop offset="100%" stopColor="#00BFFF" />
    </linearGradient>
    <circle cx="20" cy="20" r="20" fill="url(#starGradient)" />
    <path d="M20 12L22.5 17L28 18L24 22L25 27.5L20 25L15 27.5L16 22L12 18L17.5 17L20 12Z" fill="black" />
  </svg>
);

export const OkxIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="8" fill="#8BC34A"/>
    <path d="M15 15H12V18H15V15Z" fill="black"/>
    <path d="M25 15H22V18H25V15Z" fill="black"/>
    <path d="M15 22H12V25H15V22Z" fill="black"/>
    <path d="M25 22H22V25H25V22Z" fill="black"/>
  </svg>
);

export const BinanceIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="8" fill="#333333"/>
    <path d="M20 12L23 15L20 18L17 15L20 12Z" fill="#F3BA2F"/>
    <path d="M26 18L29 21L26 24L23 21L26 18Z" fill="#F3BA2F"/>
    <path d="M20 24L23 27L20 30L17 27L20 24Z" fill="#F3BA2F"/>
    <path d="M14 18L17 21L14 24L11 21L14 18Z" fill="#F3BA2F"/>
    <path d="M20 18L23 21L20 24L17 21L20 18Z" fill="#F3BA2F"/>
  </svg>
);
